import React from 'react';
import svgIcon from 'components/hoc/svgIcon';
import PropTypes from 'prop-types';

const Favourite = ({ isActive }) =>
  isActive ? (
    <svg viewBox="0 0 26 24">
      <path d="M12.868 24c-.135 0-.268-.027-.395-.081C11.964 23.699 0 18.439 0 8.568 0 4.119 3.141.5 7 .5c2.292 0 4.516 1.644 5.982 3.5C14.382 2.139 16.493.5 19 .5c3.794 0 7 3.695 7 8.068 0 9.81-12.22 15.13-12.74 15.352a.985.985 0 01-.392.08" />
    </svg>
  ) : (
    <svg viewBox="0 0 26 24">
      <path d="M19 .5c3.794 0 7 3.695 7 8.068 0 9.81-12.22 15.13-12.74 15.352a1.004 1.004 0 01-.787-.001C11.964 23.699 0 18.439 0 8.568 0 4.119 3.141.5 7 .5c2.292 0 4.516 1.644 5.982 3.5C14.382 2.139 16.493.5 19 .5zm0 2c-2.225 0-4.151 2.04-5.126 3.787a.997.997 0 01-.866.513h-.007c-.357 0-.689-.192-.867-.501C11.048 4.411 8.937 2.5 7 2.5c-2.71 0-5 2.779-5 6.068 0 7.628 8.877 12.364 10.871 13.329l.218-.106.258-.129C16.033 20.3 24 15.658 24 8.568 24 5.279 21.71 2.5 19 2.5z" />
    </svg>
  );

Favourite.propTypes = {
  isActive: PropTypes.bool,
};

Favourite.defaultProps = {
  isActive: false,
};

export default svgIcon(Favourite);
